<template>
    <v-card>
      <v-container style="max-width: 1500px">
        <v-row>
          <v-col cols="12">
            <v-toolbar color="secondary" flat dense>
              <v-toolbar-title>Accounts Setup</v-toolbar-title>
            </v-toolbar>
          </v-col>
        </v-row>
  
        <v-row class="shortcuts-padding">
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="12"
          >
            <v-row dense>
              <v-col cols="12" md="3">
                <v-btn to="/account-categories" text  left
                  ><v-icon left>mdi-plus</v-icon> Account Categories</v-btn
                ><br />
                
                <v-btn to="/accounts" text  left
                  ><v-icon left>mdi-plus</v-icon> Accounts List</v-btn
                ><br />

                <v-btn to="/account-balances" text  left
                  ><v-icon left>mdi-plus</v-icon> Accounts Balances</v-btn
                ><br />

                <v-btn to="/payment-modes" text  left
                  ><v-icon left>mdi-plus</v-icon> Payment Modes</v-btn
                ><br />
  
                <v-btn to="/journal-entry" text  left
                  ><v-icon left>mdi-plus</v-icon> Journal Entry</v-btn
                ><br />

                <v-btn to="/accounts-transfer" text  left
                  ><v-icon left>mdi-plus</v-icon> Money Transfers</v-btn
                >

                <v-btn to="/gl-accounts-setup" text  left
                  ><v-icon left>mdi-plus</v-icon> G / L Accounts Setup</v-btn
                >
              </v-col>

            </v-row>
          </v-col>
  
        </v-row>
  
        <snackbar ref="snackbar"></snackbar>
      </v-container>
    </v-card>
  </template>
  
  
  <script>
  export default {
    components: {},
    computed: {
      role() {
        return localStorage.getItem("userRole");
      },
    },
    data() {
      return {
        datacollection: {},
        loader: false,
        smsRef: null,
        loading: false,
        record: {},
        callsData: [],
        search: null,
        dashData: {},
        startField: "StartDate",
        endField: "EndDate",
        trueValue: true,
      };
    },
    methods: {
      deleteData() {
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("get", `/reset-account`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.$store.commit("loader", false);
              this.$refs.snackbar.show("Reset Done", "blue");
            } else {
              self.$store.commit("loader", false);
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(err, "red");
          });
      },
      setDate(data) {
        this.record = { ...this.record, [data.fieldName]: data.date };
      },
      resetLoader() {
        this.$store.commit("loader", false);
        this.$store.commit("btnLoader", false);
        this.$refs.snackbar.show("Done", "green");
      },
    },
    created() {

    },
  };
  </script>
  
  <style>
  .small {
    max-width: 600px;
    margin: 150px auto;
  }
  
  .cardText {
    font-weight: bold;
    font-size: 18px;
    padding: 12px;
    color: #757575;
  }
  
  .dash-btn {
    margin-top: -5px;
  }
  </style>